import { Link2, Unlink } from "lucide-react";
import type { Warehouse } from "@estelle/domain";

import { Badge } from "@/components/ui/badge";
import { isMapped } from "@/modules/warehouses/channelMapping";

/**
 * The channel location one warehouse mirrors from (M6-12, FR-WHS-2).
 *
 * Read-only: `WarehousesRepository` has no call to change which location a
 * warehouse maps to, and inventing one here would be a repository method no
 * write path backs. This says so plainly rather than disabling a control
 * that was never wired to anything.
 */
export function ChannelMapping({ warehouse }: { warehouse: Warehouse }) {
  const mapped = isMapped(warehouse);

  return (
    <div className="space-y-1.5">
      <p className="text-muted-foreground text-xs font-medium tracking-wide uppercase">
        Channel mapping
      </p>
      {mapped ? (
        <div className="space-y-1">
          <Badge variant="outline" className="font-normal">
            <Link2 />
            Mapped
          </Badge>
          <p className="text-muted-foreground font-mono text-xs break-all">
            {warehouse.externalId}
          </p>
        </div>
      ) : (
        <Badge
          variant="outline"
          className="border-warning/60 bg-warning/10 text-warning font-normal"
        >
          <Unlink />
          Not mapped — stock figures hidden
        </Badge>
      )}
      <p className="text-muted-foreground text-xs">
        Changing which channel location this maps to is a later ticket.
      </p>
    </div>
  );
}
